import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- ADD THIS
import { motion, AnimatePresence } from 'framer-motion';
import './Hero.css';

const slides = [
  {
    image: '/images/dried-flower-1.png',
    title: 'Timeless Beauty in Every Petal',
    subtitle: 'Explore a curated world of everlasting botanicals.',
  },
  {
    image: '/images/dried-flower-2.jpg',
    title: 'Nature’s Elegance Preserved',
    subtitle: 'INFUSE brings you the art of nature, captured forever.',
  },
  {
    image: '/images/dried-flower-3.jpg',
    title: 'Golden Moments, Eternal Memories',
    subtitle: 'Dried blooms crafted for lasting impressions.',
  },
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(slideInterval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="hero-section">
      <AnimatePresence mode="wait">
        <motion.div 
          key={slides[currentSlide].image}
          className="hero-background"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
        />
      </AnimatePresence>

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <motion.div 
          className="hero-text"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>{slides[currentSlide].title}</h1>
          <p className="hero-subtitle">{slides[currentSlide].subtitle}</p>
          <div className="hero-cta">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="cta-primary"
              onClick={() => navigate('/products')} // <-- REDIRECT to /products
            >
              Explore Catalogue
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="cta-secondary"
              onClick={() => navigate('/contact')}
            >
              Contact Us
            </motion.button>
          </div>
        </motion.div>
        <div className="hero-decoration">
          <div className="gold-line"></div>
          <div className="gold-circle"></div>
        </div>
      </div>

      {/* Arrow Controls */}
      <button className="arrow arrow-left" onClick={prevSlide}>‹</button>
      <button className="arrow arrow-right" onClick={nextSlide}>›</button>
    </section>
  );
};

export default Hero;